// extracted by mini-css-extract-plugin
module.exports = {"emptyNode":"JobFunction_emptyNode__5rzOJ","highlightSpan":"JobFunction_highlightSpan__t1q5b"};